<template>
  <div class="home-page">
    <LoginRequire pageId="PT004" />
    <div class="wrapper">
      <div class="header">
        <div class="title">{{ $t("home.trung_tam_phan_tich") }}</div>
        <div class="description">{{ $t("home.description") }}</div>
      </div>
      <div class="content">
        <div class="cash-flow">
          <div class="menu-cash-flow">
            <div class="menu-cash-flow-title">
              <img src="../../assets/images/cashflow.svg" />
              <span>{{ $t("home.dong_tien_dang_do_vao_nganh_nao") }}</span>
            </div>
            <div class="inds">
              <span v-for="ind in inductry" :key="ind.indCode">
                <router-link :to="'/nganh/chi-tiet-nganh?indCode=' + ind.indCode">{{
                  lang == "vi" ? ind.indName : ind.indNameEn
                }}</router-link>
              </span>
            </div>
          </div>
        </div>
        <div class="index">
          <el-menu class="el-menu-index">
            <el-sub-menu index="1">
              <template #title>
                <img src="../../assets/images/index.svg" />
                <div class="menu-title" style="padding-left: 5px">
                  <span style="padding-left: 15px; font-size: 12px"
                    >VNINDEX</span
                  >
                  <span v-if="updown > 0" style="color: var(--color-price-up)">
                    {{ updown }} | {{ percent }}%</span
                  >
                  <span v-else style="color: var(--color-price-down)"
                    >{{ updown }} | {{ percent }}%</span
                  >
                </div>
              </template>
              <el-menu-item-group>
                <el-menu-item index="1-1">
                  <a
                    target="_blank"
                    href="https://www.aseansc.com.vn/trung_tam_phan_tich/ban-tin-thi-truong/"
                  >
                    <img src="../../assets/images/anh_huong.svg" />
                    <span>{{
                      $t("home.anh_huong_cua_tin_tuc_su_kien_moi")
                    }}</span>
                  </a>
                </el-menu-item>
                <el-menu-item index="1-2">
                  <router-link :to="{ name: 'macro' }">
                    <img src="../../assets/images/tuong_quan.svg" />
                    <span>{{
                      $t("home.tuong_quan_giua_cac_yeu_to_va_vni")
                    }}</span>
                  </router-link>
                </el-menu-item>
                <el-menu-item index="1-3">
                  <router-link :to="{ name: 'calendar' }">
                    <img src="../../assets/images/lich_su_kien.svg" />
                    <span>{{ $t("home.lich_su_kien_kinh_te") }}</span>
                  </router-link>
                </el-menu-item>
              </el-menu-item-group>
            </el-sub-menu>
          </el-menu>
        </div>
        <div class="stock">
          <div class="menu-stock">
            <div class="menu-stock-title">
              <img src="../../assets/images/stock.svg" />
              <span>{{ $t("home.ma_cp_hut_dong_tien") }}</span>
            </div>
            <div class="symbols">
              <span v-for="symbol in symbols" :key="symbol">
                <router-link
                  :to="{ name: 'enterprise', query: { secCode: symbol } }"
                  >{{ symbol }}</router-link
                >
              </span>
            </div>
          </div>
        </div>
        <div class="tools">
          <el-menu class="el-menu-tools">
            <el-sub-menu index="1">
              <template #title>
                <img src="../../assets/images/tools.svg" />
                <div class="menu-title" style="padding-left: 5px">
                  <span
                    style="padding-left: 15px; font-size: var(--font-size)"
                    >{{ $t("home.cong_cu_tim_kiem_co_hoi") }}</span
                  >
                </div>
              </template>
              <el-menu-item-group>
                <el-menu-item index="1-1">
                  <router-link :to="{ name: 'analysis' }">
                    <img src="../../assets/images/ptkt.svg" />
                    <span>{{ $t("home.xac_dinh_diem_mua_bang_ptkt") }}</span>
                  </router-link>
                </el-menu-item>
                <el-menu-item index="1-2">
                  <router-link :to="{ name: 'stock-filter' }">
                    <img src="../../assets/images/filter.svg" />
                    <span>{{ $t("home.sang_loc_co_phieu") }}</span>
                  </router-link>
                </el-menu-item>
                <el-menu-item index="1-3">
                  <router-link :to="{ name: 'signal' }">
                    <img src="../../assets/images/signal.svg" />
                    <span>{{ $t("home.tin_hieu_ky_thuat") }}</span>
                  </router-link>
                </el-menu-item>
              </el-menu-item-group>
            </el-sub-menu>
          </el-menu>
        </div>
      </div>
      <div class="footer">
        <div class="vnindex">
          <div v-if="updown > 0" class="vnindex-info">
            <span
              ><span
                style="color: var(--color-price-up); font-weight: bold"
                :class="{ active: updatedPrice }"
                >{{ price }}</span
              >
            </span>
            <span
              ><span
                style="color: var(--color-price-up)"
                :class="{ active: updatedUpDown }"
                >{{ updown }} ({{ percent }}%) <i class="ri-arrow-up-s-fill"></i
              ></span>
            </span>
          </div>
          <div v-else-if="updown == 0" class="vnindex-info">
            <span
              ><span
                style="color: var(--color-price-no-down); font-weight: bold"
                :class="{ active: updatedPrice }"
                >{{ price }}</span
              ></span
            >
            <span
              ><span
                style="color: var(--color-price-no-down)"
                :class="{ active: updatedUpDown }"
                >{{ updown }} ({{ percent }}%)</span
              ></span
            >
          </div>
          <div v-else class="vnindex-info">
            <span
              ><span
                :class="{ active: updatedPrice }"
                style="color: var(--color-price-down); font-weight: bold"
                >{{ price }}</span
              ></span
            >
            <span
              ><span
                :class="{ active: updatedUpDown }"
                style="color: var(--color-price-down)"
                >{{ updown }} ({{ percent }}%)
                <i class="ri-arrow-up-s-fill"></i></span
            ></span>
          </div>
          <div class="vnindex-icon">
            <img :src="mascot" style="height: 158px" />
          </div>
        </div>
        <div class="disclaimer">
          <div>{{ $t("home.disclaimer") }}</div>
          <p>-----------------------------------------</p>
          <p>
            <b>{{
              lang == "vi"
                ? "Công ty Cổ phần Chứng khoán Asean"
                : "Asean Securities Join Stock Company"
            }}</b>
            ----
            <b>Hotline: </b>
            <span>1900 638 088 --- </span>
            <b>Website: </b>
            <span>aseansc.com.vn --- </span>
            <b>Email: </b>
            <span>cskh@aseansc.com.vn</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import homeService from "@/api/homeService";
import { TokenService } from "../../api/storageService";
import { APP_CONFIG } from "@/contants";
import LoginRequire from "@/components/LoginRequire.vue";

export default {
  components: {
        LoginRequire
    },
  data() {
    return {
      exchange: "HOSE",
      lang: "vi",
      symbols: [],
      inductry: [],
      updown: 0,
      percent: 0,
      price: 0,
      refPrice: 0,
      socket: null,
      updatedPrice: true,
      updatedUpDown: true,
      mascotList: [],
      mascot: "",
    };
  },
  mounted() {
    console.log("start connect to socket");
    this.socket = new WebSocket(APP_CONFIG.socketUrl);

    this.socket.onmessage = (event) => {
      //console.log(event.data)
      this.updateRealTime(event.data);
    };
    this.socket.onopen = function (event) {
      console.log("connected");

      this.send(
        JSON.stringify({ event: "subscribe", channel: "AlgoRealtime:VNIndex" })
      );
    };
    this.socket.onclose = function () {
      console.log("closed");
    };
    // this.getPermission();
  },
  unmounted() {
    this.socket.close();
    this.socket = null;
    console.log("Closing connection to WebSocket Server");
  },
  created() {
    this.lang = TokenService.getLang() == "" ? "vi" : TokenService.getLang();
    this.getSecMostInflow();
    this.getIndMostInflow();
    this.getIndex();
  },
  methods: {
    ...mapActions("common", ["setLoading"]),

    updateRealTime(obj) {
      let result = obj.split(";");
      if (result[1] === "1") {
        for (let i = 0; i < result.length; i++) {
          if (result[i].split(":")[0] === "2") {
            this.price = parseFloat(result[i].split(":")[1]);
          }
          if (
            result[i].split(":")[0] === "3" &&
            result[i].split(":").length > 0
          ) {
            this.updown = parseFloat(result[i].split(":")[1]);
          }
          if (result[i].split(":")[0] === "4") {
            this.percent = parseFloat(result[i].split(":")[1]);
          }
        }
        this.getMascotImage();
      }
    },

    getMascotImage() {
      let point = this.updown;
      if (point < -40) {
        this.mascot = this.mascotList.DESIGN_1;
      } else if (point < -20 && point >= -40) {
        this.mascot = this.mascotList.DESIGN_2;
      } else if (point <= -5 && point >= -20) {
        this.mascot = this.mascotList.DESIGN_3;
      } else if (point >= -5 && point < 5) {
        this.mascot = this.mascotList.DESIGN_4;
      } else if (point >= 5 && point < 20) {
        this.mascot = this.mascotList.DESIGN_5;
      } else if (point >= 20 && point < 40) {
        this.mascot = this.mascotList.DESIGN_6;
      } else if (point >= 40) {
        this.mascot = this.mascotList.DESIGN_7;
      }
    },

    getMascot() {
      this.loadding = true;
      homeService
        .getMascot()
        .then((response) => {
          if (response.status == 200) {
            this.mascotList = response.data[0];
            this.getMascotImage();
          } else {
            messageBox.showWarning("Có lỗi xảy ra");
          }
        })
        .finally(() => {
          this.loadding = false;
        });
    },

    getSecMostInflow() {
      this.loadding = true;
      homeService
        .getSecMostInflow()
        .then((response) => {
          if (response.status == 200) {
            this.symbols = response.data?.map((item) => item.SECURITY_CODE);
          } else {
            messageBox.showWarning("Có lỗi xảy ra");
          }
        })
        .finally(() => {
          this.loadding = false;
        });
    },

    getIndMostInflow() {
      this.loadding = true;
      homeService
        .getIndMostInflow()
        .then((response) => {
          if (response.status == 200) {
            this.inductry = response.data;
          } else {
            messageBox.showWarning("Có lỗi xảy ra");
          }
        })
        .finally(() => {
          this.loadding = false;
        });
    },

    getIndex() {
      this.loadding = true;
      homeService
        .getIndex(this.exchange)
        .then((response) => {
          if (response.status == 200) {
            this.board = response.data[0];
            if (this.board?.IndexValue == null) {
              this.price = 0;
              this.refPrice = 0;
              this.updown = 0;
              this.percent = 0;
            } else {
              this.price = this.board?.IndexValue;
              this.refPrice = this.board?.Ref_Index;
              this.updown = parseFloat(
                this.board?.IndexValue - this.board?.Ref_Index
              ).toFixed(2);
              this.percent = (
                (this.updown * 100) /
                this.board?.Ref_Index
              ).toFixed(2);
            }
            this.getMascot();
          } else {
            messageBox.showWarning("Có lỗi xảy ra");
          }
        })
        .finally(() => {
          this.loadding = false;
        });
    },
  },
  watch: {
    "$store.state.common.lang": function () {
      this.lang = this.$store.state.common.lang;
    },
    price: function (oldValue, newValue) {
      this.updatedPrice = true;
      setInterval(() => {
        this.updatedPrice = false;
      }, 2000);
    },
    updown: function (oldValue, newValue) {
      this.updatedUpDown = true;
      setInterval(() => {
        this.updatedUpDown = false;
      }, 2000);
    },
  },
};
</script>

<style>
.el-sub-menu .el-sub-menu__icon-arrow {
  font-size: 18px;
}
</style>
<style scoped>
.el-menu-item a span {
  font-size: var(--font-size);
}

.el-menu {
  border-radius: 7px;
}

.el-sub-menu {
  margin: 2px;
}

.footer {
  height: 140px;
  display: flex;
  align-items: end;
}

.disclaimer {
  padding: 0 20px 15px 20px;
  color: var(--text-color-2);
  width: 70%;
}

.el-menu-item a {
  display: flex;
}

.el-menu-item a img {
  padding-right: 5px;
}

.inds {
  display: flex;
  flex-direction: column;
  padding-top: 10px;
}

.inds span {
  font-size: 14px;
}

.symbols {
  display: flex;
  padding-top: 10px;
  flex-wrap: wrap;
}

.symbols span {
  padding: 0 2px;
  font-size: 14px;
}

.inds span a {
  text-transform: uppercase;
}

.symbols span a:hover,
.inds span a:hover {
  text-decoration: underline !important;
}

.symbols span::after {
  content: ", ";
}

.symbols span:last-child:after {
  content: "";
}

.active {
  background-color: goldenrod;
  padding: 1px 4px !important;
  color: #fff !important;
}

.branch span {
  color: var(--text-color) !important;
}

.content {
  background-image: var(--icon-home-old);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  height: 80%;
  width: 100%;
}

.wrapper {
  height: 100%;
  width: 100%;
  position: relative;
}

.vnindex-info {
  height: 85px;
  border: 1px solid #000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  padding: 6px 20px;
  border-radius: 5px;
  background-color: var(--bg-color-1);
  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
}

.vnindex-info span:first-child {
  font-weight: 500;
  font-size: 16px;
  text-align: center;
  padding-bottom: 5px;
}

.vnindex-info span:last-child {
  font-weight: 500;
  font-size: 14px;
  color: #27b971;
}

.vnindex {
  position: absolute;
  bottom: 30px;
  right: 100px;
  display: flex;
  align-items: center;
}

.el-menu-item span {
  text-wrap: wrap;
  color: var(--text-color);
}

.el-menu-item i {
  font-size: 16px;
  padding-right: 5px;
  color: var(--text-color);
}

.el-menu-item {
  padding: 10px 5px 10px 10px !important;
  height: fit-content;
  line-height: 1.6;
}

.menu-title {
  display: flex;
  flex-direction: column;
  line-height: normal;
}

.menu-stock {
  border: 1px solid #e8a259;
  padding: 10px;
  border-radius: 7px;
}

.menu-cash-flow {
  border: 1px solid #30bead;
  padding: 10px;
  border-radius: 7px;
}

.menu-cash-flow-title {
  display: flex;
  color: #30bead;
}

.menu-cash-flow-title span {
  padding-left: 10px;
}

.menu-stock-title {
  display: flex;
  color: #e8a259;
}

.el-menu-index .menu-title span:first-child {
  color: #e53e3e;
}

.menu-title span:last-child {
  padding-top: 5px;
  font-weight: 500;
  font-size: 16px;
}

.el-menu-cash-flow {
  width: 250px !important;
  border: 1px solid #30bead;
}

.el-menu-index {
  width: 250px !important;
  border: 1px solid #e53e3e;
}

.el-menu-tools {
  width: 250px !important;
  border: 1px solid #7f6ee9;
}

.el-menu-stock {
  width: 290px !important;
  border: 1px solid #e8a259;
}

.el-menu {
  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
}

.el-menu-tools .menu-title span:first-child {
  color: #7f6ee9;
}

.tools {
  width: 200px;
  position: absolute;
  top: 60%;
  left: 54%;
}

.index {
  width: 200px;
  position: absolute;
  top: 17%;
  left: 35%;
}

.stock {
  border-radius: 7px;
  width: 230px;
  position: absolute;
  top: 50%;
  left: 28%;
  background-color: var(--bg-menu);
}

.cash-flow {
  width: 260px;
  position: absolute;
  top: 35%;
  left: 58%;
  background-color: var(--bg-menu);
  border-radius: 7px;
}

.title {
  font-weight: 500;
  font-size: 22px;
  padding-bottom: 10px;
  color: var(--text-color);
}

.description {
  color: var(--text-color);
}

.header {
  padding: 20px 10px 10px 20px;
}

.wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.home-page {
  background: var(--bg-home-old);
  height: 100%;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}

@media only screen and (max-width: 768px) {
  .wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
  }

  .index {
    top: 15%;
    left: 20%;
  }

  .cash-flow {
    top: 24%;
    left: 45%;
  }

  .stock {
    top: 42%;
    left: 5%;
  }

  .tools {
    top: 55%;
    left: 34%;
    z-index: 1;
  }

  .home-page {
    margin-bottom: 70px;
    height: 122%;
  }

  .footer {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .vnindex-icon img {
    height: 120px !important;
  }

  .vnindex {
    width: 100%;
    bottom: 10px;
    right: 0;
    position: relative;
    justify-content: center;
  }

  .disclaimer {
    padding: 10px;
    color: var(--text-color-2);
    width: 100%;
  }

  .content {
    height: 55%;
  }
}
</style>
